<template>
    <div class="setting-box">
        <div class="setting-title">选项设置</div>
        <div class="setting-content">
            <div class="setting-content-item item-row">
                <span>样式</span>
                <div class="select-box">
                    <el-select v-model="dataList.icon" class="m-2" placeholder="Select" size="large">
                        <el-option v-for="item in iconOptions" :key="item.value" :label="item.label" :value="item.value">
                            <div style="margin-top: 5px">
                                <score-number v-if="item.value === 'Number'" :iconType="item.value" />
                                <score-ruler v-else-if="item.value === 'Ruler'" :iconType="item.value" />
                                <score-icon v-else :iconType="item.value" />
                            </div>
                        </el-option>
                    </el-select>
                    <div class="chose-icon">
                        <score-number v-if="dataList.icon === 'Number'" :iconType="dataList.icon" />
                        <score-ruler v-else-if="dataList.icon === 'Ruler'" :iconType="dataList.icon" />
                        <score-icon v-else :iconType="dataList.icon" />
                    </div>
                </div>
            </div>
            <div class="setting-content-item item-row">
                <span>分值</span>
                <div class="select-box">
                    <el-select disabled v-model="dataList.score" class="m-2" placeholder="Select" size="large">
                        <el-option v-for="item in scoreOptions" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                </div>
            </div>
            <div class="setting-content-item item-row">
                <span>显示分值说明</span>
                <el-switch v-model="dataList.showScoreExplain" class="ml-2" />
            </div>
            <div class="setting-content-item" v-show="dataList.showScoreExplain">
                <span>分值说明</span>
                <div class="item-row" v-for="(item, index) in dataList.score">
                    <span class="score">{{ index + 1 }}分</span>
                    <div class="select-box">
                        <el-input class="score-input" v-model="dataList[`score${index + 1}`]"></el-input>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup name="kr-csat-setting">
import ScoreIcon from "@/components/scoreIcon/Icon.vue";
import ScoreNumber from "@/components/scoreIcon/Number.vue";
import ScoreRuler from "@/components/scoreIcon/Ruler.vue";

const props = defineProps({
    dataList: {
        type: Object,
        default: () => ({}),
    },
});

let scoreOptions = [
    { label: "5", value: 5 },
    { label: "10", value: 10, icon: "" },
];
let iconOptions = [
    { label: "Star", value: "Star", icon: "" },
    { label: "Thumbs", value: "Thumbs", icon: "" },
    { label: "Smile", value: "Smile", icon: "" },
    { label: "Love", value: "Love", icon: "" },
    { label: "Number", value: "Number", icon: "" },
    { label: "Ruler", value: "Ruler", icon: "" },
];
</script>
<style lang="scss" scoped>
@import "@/css/setting.scss";
.item-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
        flex-shrink: 0;
    }
    span.score {
        font-size: 14px;
        font-weight: 400;
        color: rgba(183, 186, 191, 1);
    }
}
.select-box {
    position: relative;
    width: 100%;
    margin-left: 6px;
    .chose-icon {
        position: absolute;
        top: 50%;
        left: 12px;
        transform: translateY(-50%);
        height: 30px;
        background-color: #fff;
        display: flex;
        align-items: center;
        pointer-events: none;
    }
}

:deep(.el-select--large) {
    width: 100%;
    position: relative;
}
:deep(.el-select-dropdown__item) {
    line-height: 44px;
}
</style>
